<template>
  <div class="mobiledeveloperdetail">
    <div class="detail_wrapper">
      <div class="detail_item">
        <div class="detail_label">Client&nbsp;Id：</div>
        <div class="detail_value">{{details.clientId}}</div>
      </div>
      <div class="detail_item">
        <div class="detail_label">Client&nbsp;Secret：</div>
        <div class="detail_value"> {{details.clientSecret}}<el-button size="mini" type="text" style="margin-left:8px;" @click="reset()">重置</el-button></div>

      </div>
      <div class="detail_item">
        <span class="detail_label">开通方式：</span>
        <span class="detail_value">
          <el-tag  size="mini" v-if="details.type == 1">按时段</el-tag>
          <el-tag size="mini" v-if="details.type == 2">按数量</el-tag>
        </span>
      </div>
      <div class="detail_item">
        <span class="detail_label">开通状态：</span>
        <span class="detail_value">
          <el-tag size="mini" v-if="details.status == 0">未生效</el-tag>
          <el-tag size="mini" type="success" v-if="details.status == 1">试用中</el-tag>
          <el-tag size="mini" type="success" v-if="details.status == 2">服务中</el-tag>
          <el-tag size="mini" type="danger" v-if="details.status == 3">已过期</el-tag>
          <el-tag size="mini" type="warning" v-if="details.status == 4">禁用</el-tag>
        </span>
      </div>
      <!-- <el-card class="layout_table"> -->

        <div style="margin-top:20px;">
          <!-- 按时段开通  显示资源 -->
          <el-table v-if="details.type == 1" :data="details.resourcePermissionList">
            <el-table-column label="资源接口" align="center" width="150px">
              <template slot-scope="scope">
                {{scope.row.apiResourceDto.name}}
              </template>
            </el-table-column>
            <el-table-column label="每日接口调用上限" prop="maxInvokePerDay" align="center" width="150px"></el-table-column>
            <el-table-column label="每日调用量上限" prop="maxDownloadPerDay" align="center" width="150px"></el-table-column>
            <el-table-column
              align="center"
               width="150px"
              label="操作">
              <template slot-scope="scope">
                <el-button size="mini" type="text" @click="pushTo(scope.row.apiResourceDto.name)">调用统计</el-button>
              </template>
            </el-table-column>
          </el-table>

          <!-- 按调用量开通 显示资源 -->
          <el-table v-if="details.type == 2"
                    :data="emptyData"
                    >
            <el-table-column label="调用试题总量" align="center" width="150px">
              <template>
                {{details.interviewQuestionLimit}}
              </template>
            </el-table-column>
            <el-table-column label="调用文档总量" align="center" width="150px">
              <template>
                {{details.downloadDocumentLimit}}
              </template>
            </el-table-column>
            <el-table-column label="调用接口总量" align="center" width="150px">
              <template >
                {{details.invokeLimit}}
              </template>
            </el-table-column>
            <el-table-column label="调用试题量" align="center" width="150px">
              <template >
                {{details.interviewQuestionCount}}
              </template>
            </el-table-column>
            <el-table-column label="调用文档量" align="center" width="150px">
              <template >
                {{details.downloadDocumentCount}}
              </template>
            </el-table-column>
            <el-table-column label="接口调用量" align="center" width="150px">
              <template>
                {{details.invokeCount}}
              </template>
            </el-table-column>
            <el-table-column label="接口调用量" align="center" width="150px">
              <template>
                <el-button size="mini" type="text" @click="pushTo(details.resourcePermissionList[2].apiResourceDto.name)">调用统计</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      <!-- </el-card> -->
    </div>
  </div>
</template>
<script type="text/babel">
import detailService from '@/service/front/detailService'
export default {
  data () {
    return {
      details: {},
      emptyData: [{}],
      tableData: []
    }
  },
  name: 'mobiledeveloperdetail',
  async mounted () {
    await this.detailService()
  },
  methods: {
    async reset () {
      this.$confirm('重置后将使用新的 Developer Id 和 Access Secret, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'info',
        customClass: 'mobileconfirm'
      }).then(async () => {
        try {
          await detailService.resetClient()
          await this.detailService()
        } catch (e) {
          this.$message.error({
            message: e && e.msg,
            customClass: 'errmsg'
          })
        }
      }).catch(() => {
      })
    },
    async detailService () {
      try {
        this.details = await detailService.fetchDetail()
      } catch (e) {
        this.$message.error({
          message: e && e.msg,
          customClass: 'errmsg'
        })
      }
    },
    pushTo (name) {
      let url = '/front/Mobilehome/developer/summary?name=' + name
      this.$store.commit('DEVDEFAULTVX', url)
      this.$router.push({path: url})
    }
  }
}
</script>
<style scoped>
  .mobiledeveloperdetail{
    height: 100%;
    width: 100%;
  }
  .mobiledeveloperdetail .detail_wrapper{
    height: 100%;
    width: 100%;
    padding: 20px 15px;
  }
  .mobiledeveloperdetail .detail_item{
    margin-bottom: 10px;
  }
  .mobiledeveloperdetail .detail_item .detail_label{
    color: #333333;
    font-size:14px;
    font-family:MicrosoftYaHei-Bold;
    font-weight:bold;
  }
  .mobiledeveloperdetail .detail_item .detail_value{
     color: #666666;
    font-size:12px;
    font-family:MicrosoftYaHei;
    font-weight:400;
    line-height: 28px;
  }

  .mobiledeveloperdetail .layout_table{
    background:#F7F7F7;
    border:1px solid #E2E2E2;
    border-radius:4px;
    margin-top: 20px;
  }
  .mobiledeveloperdetail .layout_table .content_table{
    margin: 20px 60px;
  }

</style>
<style type="text/css">

  .mobiledeveloperdetail .layout_table .content_table td,
  .mobiledeveloperdetail .layout_table .content_table th{
    border-width: 0px;
    color: #333333;
  }
  .mobiledeveloperdetail .layout_table .el-table td,
  .mobiledeveloperdetail .layout_table .el-table th.is-leaf{
    border-width: 0px;
  }

  .mobiledeveloperdetail .layout_table .el-table--enable-row-hover .el-table__body tr:hover>td,
  .mobiledeveloperdetail .layout_table .el-table th,
  .mobiledeveloperdetail .layout_table .el-table th div,
  .mobiledeveloperdetail .layout_table .el-table td,
  .mobiledeveloperdetail .layout_table .el-table td div,
  .mobiledeveloperdetail .layout_table .el-table tr{
    background: #F7F7F7;
  }
  .mobiledeveloperdetail .layout_table .el-table .el-table__header th{
    font-weight: bold;
  }
  .mobiledeveloperdetail .el-button--text{
  	color: #108EE9;
  }
</style>



// WEBPACK FOOTER //
// src/pages/front/mobile-page/mobiledeveloper/detail/index.vue